export enum PurchaseFailReason {
    USER_INPUT = 'USER_INPUT',
    OTHER = 'OTHER',
}
